import React from 'react';

import Header from "../../Header";

import './formations.css'

const Formation = ({openBurger, isOpen}) => {
    return (
        <div className="formations">
            <Header openBurger={openBurger} isOpen={isOpen} title='Formations' />
            <main className="formations__main">
                <h2 className="formation__title">FORMATIONS</h2>
                <p className="formation__descr">Débutant ou professionnel, Vous trouverez ici le catalogue complet des formations pour vous initier au Cake Design ou approfondir vos connaissances et améliorer vos techniques.</p>
                <ul className="formations__main__lists">
                    <li><a href="https://creationhloua3.systeme.io/proxy/request/2029705e92b7f3fab5f823420e5504de633d?sa=sa0012861717fd6002418426be393f6e07887de6e0">- CRÉATION DE PÂTISSERIE ÉVÈNEMENTIELLE & CAKE DESIGN</a></li>

                    <li><a href="https://creationhloua3.systeme.io/proxy/request/20301b9ccd7e53a9f390c9fa6a6a7b4fc77a?sa=sa0012861717fd6002418426be393f6e07887de6e0">- WEDDING CAKE </a></li>

                    <li><a href="https://creationhloua3.systeme.io/proxy/request/20312ca3548713784a138c12fee297198712?sa=sa0012861717fd6002418426be393f6e07887de6e0">- SWEET TABLE</a></li>

                    <li><a href="https://creationhloua3.systeme.io/proxy/request/20323b695f99066b3a473d054f6a3a8fe7f5?sa=sa0012861717fd6002418426be393f6e07887de6e0">- CINQ PARFUMS</a></li>

                    <li><a href="https://creationhloua3.systeme.io/proxy/request/203315bee53fc3c8980c73107951049570a0?sa=sa0012861717fd6002418426be393f6e07887de6e0">- CRAZY LAYER CAKE</a></li>

                    <li><a href="https://creationhloua3.systeme.io/proxy/request/2034688e60f7fa310869f963a40541dd927c?sa=sa0012861717fd6002418426be393f6e07887de6e0">- DRIP CAKE</a></li>

                    <li><a href="https://creationhloua3.systeme.io/proxy/request/20350b469896a45e22f13e2d9769e372d196?sa=sa0012861717fd6002418426be393f6e07887de6e0">- GÂTEAU CARRÉ</a></li>

                    <li><a href="https://creationhloua3.systeme.io/proxy/request/20366b79c40a7ad7877b02107cbeaf504e4d?sa=sa0012861717fd6002418426be393f6e07887de6e0">- FLEURS EN SUCRE</a></li>
                </ul>
            </main>
            
        </div>
    );
};

export default Formation;